import type { TripDetails } from "../types";

export interface TripEndpoint {
  index: number;
  label: "S" | "E" | "S/E";
  color: string;
}

export function tripEndpoints(trip: Pick<TripDetails, "count" | "finished">): TripEndpoint[] {
  if (!trip.count) return [];
  if (trip.finished && trip.count === 1) return [{ index: 0, label: "S/E", color: "#52616b" }];
  return [
    { index: 0, label: "S", color: "#17834f" },
    ...(trip.finished ? [{ index: trip.count - 1, label: "E", color: "#c23b3b" } as const] : []),
  ];
}

export function nearestTripPoint(timestamps: ArrayLike<number>, count: number, time: number) {
  const length = Math.min(count, timestamps.length);
  if (!length) return undefined;
  if (time <= timestamps[0]!) return 0;
  if (time >= timestamps[length - 1]!) return length - 1;

  let low = 0;
  let high = length - 1;
  while (low + 1 < high) {
    const middle = Math.floor((low + high) / 2);
    if (timestamps[middle]! < time) low = middle;
    else high = middle;
  }
  return time - timestamps[low]! <= timestamps[high]! - time ? low : high;
}
